<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'navpage',
  data () {
    return {
      msg: 'Welcome to the navpage'
    }
  }
}
</script>

<style lang="scss" scoped>
    @import 'navpage.scss'
</style>



// WEBPACK FOOTER //
// src/components/pages/navpage/navpage.vue